import { AiFillStar } from "react-icons/ai";
import { Link } from "react-router-dom";
import { visitWhatsapp } from "../Shared/Whatsapp";
import courses from "./../../data/courses.json";
import IconMod1 from "src/assets/images/courses/modulo1.jpg";
import IconMod2 from "src/assets/images/courses/modulo2.jpg";
import IconMod3 from "src/assets/images/courses/modulo3.jpg";
import IconMod4 from "src/assets/images/courses/modulo4.jpg";
import IconMod5 from "src/assets/images/courses/modulo5.jpg";
import IconMod6 from "src/assets/images/courses/modulo6.jpg";
import IconOfferCourse from "src/assets/images/services/coursetrading.png";
import { FaTelegram, FaPlay, FaUsers, FaClock, FaGraduationCap } from "react-icons/fa";
import { useEffect, useState } from "react";
import { classNames, money } from "src/helpers/mixins";
import APIService from "src/services/Api";

type TParams = {
  type: string;
};

export const getImageCourse = (position: string) => {
  switch (position) {
    case "Módulo 1":
      return IconMod1;
    case "Módulo 2":
      return IconMod2;
    case "Módulo 3":
      return IconMod3;
    case "Módulo 4":
      return IconMod4;
    case "Módulo 5":
      return IconMod5;
    case "Módulo 6":
      return IconMod6;
  }
};

const AcademyList: React.FC<TParams> = ({ type }) => {
  const [freeDollar, setFreeDollar] = useState<string>("0");
  
  const fetchFreeDollar = async () => {
    const x = await APIService.fetchFreeDollar({});
    setFreeDollar(x?.data?.data?.dollar);
  };

  useEffect(() => {
    fetchFreeDollar();
  }, []);

  const totalPrice = courses.map((c) => c.priceUsd).reduce((partial, a) => partial + a, 0);
  const totalPriceCOP = totalPrice * Number(freeDollar);

  return (
    <section className="w-full mx-auto">
      {/* Hero Section - Smaller with original background */}
      <div className="w-full lg:w-10/12 max-w-6xl mx-auto mt-4 rounded-sm bg-image-academy flex flex-col items-center justify-center md:px-4 px-2 md:py-10 py-8 mx-auto bg-academy-list gap-4">
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full mb-4 shadow-lg">
            <FaGraduationCap className="text-white text-2xl" />
          </div>
          <div className="w-fit mx-auto text-center flex items-center gap-2 justify-center font-bold text-xl lg:text-2xl text-white">
            Aprende a dominar los mercados financieros
          </div>
          <div className="w-fit mt-2 mx-auto text-center flex items-center gap-2 justify-center font-bold text-lg lg:text-xl text-white/90">
            ¡Únete a nuestra academia de trading!
          </div>
          <Link
            to="https://t.me/KForexDeriv"
            target="_blank"
            className="inline-flex items-center gap-3 bg-white/20 backdrop-blur-sm text-white font-bold px-6 py-3 rounded-xl hover:bg-white/30 transition-all duration-300 transform hover:scale-105 shadow-lg mt-4"
          >
            <FaTelegram size={20} />
            Unirme al canal de Telegram
          </Link>
        </div>
      </div>

      {/* Special Offer Section */}
      <div className="max-w-6xl mx-auto px-4 py-8">
        <div className="bg-gradient-to-r from-green-admin/20 to-green-admin-light/30 rounded-2xl p-6 md:p-8 shadow-xl border border-green-admin/10">
          <div className="grid md:grid-cols-2 gap-6 items-center">
            <div className="text-center md:text-left">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-green-admin/20 rounded-full mb-4">
                <FaPlay className="text-green-admin text-xl" />
              </div>
              <h2 className="text-2xl md:text-3xl font-black text-gray-800 mb-3">
                ¡Oferta Especial!
              </h2>
              <p className="text-gray-700 text-lg mb-4 font-semibold">
                Compra todos los cursos y recibe un <span className="text-3xl font-black text-green-admin">50%</span> de descuento
              </p>
              <div className="space-y-1 text-gray-600">
                <div className="line-through text-sm font-medium">
                  Antes: 1500 USD
                </div>
                <div className="text-xl font-black text-green-admin">
                  Ahora: {totalPrice} USD
                </div>
                <div className="text-sm font-semibold">
                  ó {money(totalPriceCOP)} COP
                </div>
              </div>
            </div>
            <div className="flex justify-center">
              <img
                onClick={() => visitWhatsapp("Hola, Quisiera mas información a cerca del curso de trading de ISF.")}
                src={IconOfferCourse}
                alt="course offer"
                className="rounded-xl shadow-lg cursor-pointer transform hover:scale-105 transition-all duration-300 max-w-full"
              />
            </div>
          </div>
          <div className="text-center mt-6">
            <button
              onClick={() => visitWhatsapp("Hola, Quisiera mas información a cerca del curso de trading de ISF.")}
              className="bg-green-admin text-white font-bold px-6 py-3 rounded-xl hover:bg-green-admin-dark transition-all duration-300 transform hover:scale-105 shadow-lg"
            >
              ¡Comprar ahora!
            </button>
          </div>
        </div>
      </div>

      {/* Courses Grid */}
      <div className={classNames(
        type === "home" ? "max-w-7xl" : "max-w-6xl",
        "mx-auto px-4 pb-12"
      )}>
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-3">
            Nuestros Cursos
          </h2>
          <p className="text-gray-600 text-base max-w-2xl mx-auto">
            Descubre nuestra colección completa de cursos diseñados para convertirte en un trader profesional
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {courses?.map((course, index) => (
            <CourseCard
              key={index}
              course={course}
              index={index}
              type={type}
              freeDollar={freeDollar}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

const CourseCard = ({ course, index, type, freeDollar }: any) => {
  return (
    <div className="group bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 overflow-hidden">
      {/* Course Image */}
      <div className="relative overflow-hidden">
        <Link
          to={type === "home" ? `/academia/detalle/${index}` : `/aprender/detalle/${index}`}
        >
          <img
            className="w-full h-40 object-cover group-hover:scale-105 transition-transform duration-300"
            src={getImageCourse(course.position)}
            alt={`Imagen curso ${course.name}`}
          />
        </Link>
        <div className="absolute top-3 right-3 bg-green-admin text-white px-2 py-1 rounded-full text-xs font-bold">
          {course.position}
        </div>
      </div>

      {/* Course Content */}
      <div className="p-4">
        <h3 className="font-bold text-lg text-gray-800 mb-2 group-hover:text-green-admin transition-colors duration-300">
          {course.name}
        </h3>
        
        <p className="text-gray-600 text-sm mb-3 line-clamp-2">
          {course.description.substring(0, 80)}...
        </p>

        {/* Course Stats */}
        <div className="flex items-center justify-between mb-3 text-xs text-gray-500">
          <div className="flex items-center gap-1">
            <FaUsers className="text-green-admin" />
            <span>({course.opinions.length}) Opiniones</span>
          </div>
          <div className="flex items-center gap-1">
            <FaClock className="text-green-admin" />
            <span>8h</span>
          </div>
        </div>

        {/* Rating */}
        <div className="flex items-center justify-center mb-3">
          {[1, 2, 3, 4, 5].map((_, i) => (
            <AiFillStar key={i} size={14} className="text-yellow-400" />
          ))}
        </div>

        {/* Price Section */}
        <div className="border-t border-gray-100 pt-3">
          <div className="flex items-center justify-between mb-2">
            <span className="text-gray-500 line-through text-xs">
              {course.priceBefore}
            </span>
            <span className="bg-yellow-400 text-black px-2 py-1 rounded-full font-bold text-xs">
              {course.priceNow}
            </span>
          </div>
          
          <div className="text-center text-gray-600 text-xs mb-3">
            ó {money(Number(course.priceUsd) * Number(freeDollar))} COP
          </div>

          {/* Action Buttons */}
          <div className="space-y-2">
            <Link
              to={type === "home" ? `/academia/detalle/${index}` : `/aprender/detalle/${index}`}
              className="block w-full text-center bg-gray-100 text-gray-700 font-semibold py-2 px-3 rounded-lg hover:bg-gray-200 transition-colors duration-300 text-sm"
            >
              Más información
            </Link>
            
            <button
              onClick={() => visitWhatsapp()}
              className="w-full bg-green-admin text-white font-bold py-2 px-3 rounded-lg hover:bg-green-admin-dark transition-all duration-300 transform hover:scale-105 text-sm"
            >
              Comprar aquí
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AcademyList;
